import React from "react"
import styles from "./Button.module.scss"

const ButtonLarge = (props: any) => {
    return (
        <button className={styles.button_large} {...props}>
            {props.children}
        </button>
    )
}

export default ButtonLarge
